// Gorro de Natal (vermelho, com pompom e aba branca) para o personagem na época do Natal.
// 14×8, a última linha encosta na testa (linha 5 do quadro do personagem; os olhos ficam nas
// linhas 6–7 e não são cobertos). Só tokens da paleta. Luz do alto-esquerda.

import { sprite } from './pix.js';
import type { PixelSprite } from './types.js';

export const GORRO_NATAL: PixelSprite = sprite(
  [
    '...........ww.',
    '..........wwww',
    '.........rrrrr',
    '........orrrr.',
    '.......orrrrr.',
    '.....orrrrrrr.',
    '..owwwwwwwwwwo',
    '.owWwWwWwWwWo.',
  ],
  { o: 'red0', r: 'red2', w: 'white3', W: 'white2' },
);
